import * as React from 'react';
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import DownloadIcon from '@mui/icons-material/Download';
import {
  Box, Container, Grid, Typography, TextField,
  Button, MenuItem, Select, InputLabel, Snackbar, Alert, CircularProgress,
  Dialog, DialogTitle, DialogContent, DialogActions, Autocomplete, Paper,
  Stepper, Step, StepLabel, Card, CardContent, Divider, FormHelperText,
  List, ListItem, ListItemText, ListItemIcon
} from "@mui/material";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useQuery } from "@apollo/client";
import { GET_MEMBER_DETAILS } from "../graphql/queries";
import {
  districts, states, stars, raasis,
  maritalStatusOptions, idProofTypes, panCardOptions
} from "../utils/formDataUtils";
import { motion } from "framer-motion";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useMutation } from "@apollo/client";
import { EDIT_MEMBER_MUTATION } from "../graphql/mutations";
import TKSMemberCard from "./TKSMemberCard";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { REST_URI,RAZORPAY_KEY } from '../graphql/client';


const steps = ['Personal Information', 'Additional Details', 'Payment', 'Membership'];

export default function FormComponent() {
  const navigate = useNavigate();
  const [mobile, setMobile] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [isPaymentLoading, setIsPaymentLoading] = useState(false);
  const [formData, setFormData] = useState({
    Occupation: "",
    Address: "",
    Email: "",
    Family_Details: "",
    Marital_Status: "",
    ID_Proof_Type: "",
    Pan_Card: "",
    Star: "",
    Raasi: "",
    Kootram: "",
    Kuladeivam: "",
    Pan_Number: "",
    ID_Proof_Number: ""
  });
  // Inside your component
  const [editMember] = useMutation(EDIT_MEMBER_MUTATION);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const { loading, error, data, refetch } = useQuery(GET_MEMBER_DETAILS, {
    variables: { mobile },
    skip: !mobile,
  });



  const member = data?.member || {};
  const isPaymentPending = member?.Payment_Status !== "Paid";
  const paymentContainer = useRef(null);
  const [orderId, setOrderId] = useState(null);
  const [finalAmount, setFinalAmount] = useState(null);
  const cardRef = useRef(null);
  const [maritalStatusInputRef, starInputRef, raasiInputRef] = [useRef(null), useRef(null), useRef(null)];
  useEffect(() => {
    const storedMobile = localStorage.getItem("mobile");
    if (storedMobile) setMobile(storedMobile);

    if (data?.member) {
      setFormData(prev => ({
        ...prev,
        Occupation: member.Occupation || "",
        Address: member.Address || "",
        Email: member.Email || "",
        Family_Details: member.Family_Details || "",
        Marital_Status: member.Marital_Status || "",
        ID_Proof_Type: member.ID_Proof_Type || "",
        Pan_Card: member.Pan_Card || "",
        Star: member.Star || "",
        Raasi: member.Raasi || "",
        Kootram: member.Kootram || "",
        Kuladeivam: member.Kuladeivam || "",
        Pan_Number: member.Pan_Number || "",
        ID_Proof_Number: member.ID_Proof_Number || ""
      }));
    }
  }, [data]);

  const isPanValid = formData.Pan_Card === "Yes" && /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(formData.Pan_Number);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleRadioChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handlePanChange = (e) => {
    const value = e.target.value;

    if (value === "No" && member.Pan_Number) {
      setSnackbarMessage("You have already provided a PAN Number. You cannot change it to 'No'.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    setFormData(prev => ({
      ...prev,
      Pan_Card: value,
      ...(value === "No" && { Pan_Number: "" })
    }));

    if (value === "No" && member.ID_Card?.toLowerCase() !== "generated") {
      setOpenDialog(true);
    }
  };

  const validateForm = () => {

  const newErrors = {};

  // Basic required fields
  if (!formData.Occupation?.trim()) newErrors.Occupation = "Occupation is required";
  if (!formData.Address?.trim()) newErrors.Address = "Address is required";
  // if (!formData.Email?.trim()) {
  //   newErrors.Email = "Email is required";
  // } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.Email)) {
  //   newErrors.Email = "Enter a valid email address";
  // }
  if (!formData.Family_Details?.trim()) newErrors.Family_Details = "Family Details is required";
  if (!formData.Marital_Status?.trim()) newErrors.Marital_Status = "Marital Status is required";
  if (!formData.ID_Proof_Type) newErrors.ID_Proof_Type = "ID Proof selection is required";
 
  if (!formData.ID_Proof_Number?.trim()) newErrors.ID_Proof_Number = "ID Proof Number is required";
  
  // PAN Card selection
  if (!formData.Pan_Card?.trim()) {
    newErrors.Pan_Card = "PAN Card selection is required";
  }

  // PAN Number validation if PAN Card is Yes
  if (formData.Pan_Card?.toLowerCase() === "yes" && !formData.Pan_Number?.trim()) {
    newErrors.Pan_Number = "PAN Number is required";
  }

 
  setErrors(newErrors);

  if (Object.keys(newErrors).length > 0) {
    setSnackbarMessage("Please fill all the mandatory fields");
    setSnackbarSeverity("error");
    setSnackbarOpen(true);
    return false;
  }

  return true;
};


  const handleNext = () => {
    if (activeStep === 1 && !validateForm()) return;
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    window.scrollTo(0, 0);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    window.scrollTo(0, 0);
  };

  const handleSubmit = async () => {
    window.scrollTo(0, 0);
    if (!validateForm()) return;

    const formattedDob = new Date(member.DOB).toLocaleDateString('en-CA');

    try {
      setIsLoading(true);
      
      
      const { data } = await editMember({
        variables: {
          id: member.id,
          First_Name: member.First_Name,
          Last_Name: member.Last_Name,
          Mobile_Number: member.Mobile_Number,
          DOB: formattedDob,
          City: member.City,
          District: member.District,
          State: member.State,
          Pincode: member.Pincode,
          Email: formData.Email,
          Occupation: formData.Occupation,
          Address: formData.Address,
          Marital_Status: formData.Marital_Status,
          ID_Proof_Type: formData.ID_Proof_Type,
          ID_Proof_Number: formData.ID_Proof_Number,
          Pan_Card: formData.Pan_Card,
          Pan_Number: formData.Pan_Number,
          Star: formData.Star,
          Raasi: formData.Raasi,
          Kootram: formData.Kootram,
          Kuladeivam: formData.Kuladeivam,
          Family_Details: formData.Family_Details,
        }
      });

      console.log(data.editMember);

      if (data?.editMember) {
        setIsSubmitted(true);
        setSnackbarMessage("Details submitted successfully!");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        setActiveStep(2); // Move to payment step
        window.scrollTo(0, 0); // Scroll to top after successful submission
        await refetch();
      }

    } catch (error) {
      console.error("Error:", error);
      setSnackbarMessage(error.message || "Something went wrong!");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleProceedPayment = async () => {
    try {
      const amount = 2000;
      const mobile = localStorage.getItem("mobile");

      // Making a call to your backend to create the Razorpay order
      const response = await fetch(`${REST_URI}/create-order`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ amount, mobile }) // Send amount for the order creation
      });

      if (!response.ok) {
        throw new Error(`Server Error: ${response.status}`);
      }

      const orderData = await response.json();
      console.log("Order Data:", orderData);

      if (!orderData.orderId || !orderData.amount) {
        throw new Error("Invalid order response");
      }

      // Set orderId and amount (in paise)
      setOrderId(orderData.orderId);
      setFinalAmount(orderData.amount);
    } catch (error) {
      console.error("Error fetching order:", error);
      alert("Failed to create order. Please try again.");
    }

  };

  useEffect(() => {
    const mobile = localStorage.getItem("mobile");

    if (orderId && finalAmount && paymentContainer.current) {
      const options = {
        key: RAZORPAY_KEY,
        amount: finalAmount,
        currency: "INR",
        name: "TKS Trust",
        description: "UPI QR Payment",
        order_id: orderId,
        image: "/CWA_logo.png", // 🔹 Add a custom logo
        theme: {
          color: "#FFA500", // 🔹 Primary brand color

          hide_topbar: false, // 🔹 Show/hide the top bar
        },
        modal: {
          backdropclose: false, // 🔹 Prevent closing by clicking outside
          confirm_close: true, // 🔹 Ask for confirmation before closing
          animation: true, // 🔹 Smooth opening animation
        },
        handler: async function (response) {
          console.log("Payment Successful:", response);

          localStorage.setItem("payment_completed", "true");
          localStorage.setItem("payment_status", "Paid")

          const mobile = localStorage.getItem("mobile");

          // Now, instead of calling Google Apps Script, we'll call your backend to verify payment
          const verifyParams = new URLSearchParams({
            paymentId: response.razorpay_payment_id, // Razorpay Payment ID
            orderId: orderId, // Order ID
          }).toString();

          try {
            const verifyResponse = await fetch(`${REST_URI}/verify-payment`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                paymentId: response.razorpay_payment_id,
                orderId: orderId,
                signature: response.razorpay_signature, // Include signature if needed for verification
              }),
            });

            const verifyData = await verifyResponse.json();
            setSnackbarMessage(verifyData.message); // Show success/error message
            setSnackbarOpen(true);
            setActiveStep(3);
          } catch (error) {
            console.error("Error verifying payment:", error);
            setSnackbarMessage("Payment verification failed.");
            setSnackbarOpen(true);
          }
        },


        payment_capture: 1,
        method: {
          upi: true,
          netbanking: true,
          card: true,
        },
        upi: {
          flow: "collect",
        },
        prefill: {
          contact: mobile,
        },
        container: paymentContainer.current, // Embed inside this div
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open();
    }
  }, [orderId, finalAmount]);

  const handleCloseSnackbar = () => setSnackbarOpen(false);
  const handleKeyDown = (e) => e.key === "Enter" && e.preventDefault();

  if (loading) return <LoadingIndicator />;
  if (error) return <ErrorDisplay message={error.message} />;
  if (!member) return <NoDataFound />;

  const handleDownloadIDCard = async () => {
    const element = cardRef.current;
    const canvas = await html2canvas(element, { scale: 3 });
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: [92, 60],
    });
    pdf.addImage(imgData, "PNG", 0, 0, 92, 60);
    pdf.save("Membership_ID_Card.pdf");
    // TODO: Implement ID card download logic
    console.log("Download ID Card clicked");
  };

  const renderFormStep = () => {
    switch (activeStep) {
      case 0:
        return (
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom sx={styles.sectionTitle}>
                Basic Details
              </Typography>
              <TextField
                fullWidth
                disabled
                size="small"
                label="First Name"
                name="First_Name"
                value={member.First_Name || ""}
                sx={styles.field}
              />
              <TextField
                fullWidth
                disabled
                size="small"
                label="Last Name"
                name="Last_Name"
                value={member.Last_Name || ""}
                sx={styles.field}
              />
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Date of Birth"
                  format="DD-MM-YYYY"
                  disabled
                  value={member.DOB ? dayjs(member.DOB, "YYYY-MM-DD") : null}
                  slotProps={{ textField: { fullWidth: true, size: "small" } }}
                  disableFuture
                  sx={styles.field}
                />
              </LocalizationProvider>
              <TextField
                fullWidth
                disabled
                size="small"
                label="Mobile Number"
                type="tel"
                name="Mobile_Number"
                value={member.Mobile_Number || ""}
                sx={styles.field}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom sx={styles.sectionTitle}>
                Address Details
              </Typography>
              <TextField
                fullWidth
                disabled
                size="small"
                label="City"
                name="City"
                value={member.City || ""}
                sx={styles.field}
              />
              <FormControl fullWidth disabled sx={styles.field}>
                <InputLabel>District</InputLabel>
                <Select
                  name="district"
                  label="District"
                  size="small"
                  value={member.District || ""}
                  disabled
                  sx={{
                    "& .MuiSelect-select": {
                      textAlign: "left", // 🔥 This overrides the default center alignment
                    },
                  }}
                >
                  {districts.map((district, index) => (
                    <MenuItem key={index} value={district}>{district}</MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl fullWidth disabled sx={styles.field}>
                <InputLabel>State</InputLabel>
                <Select
                  name="state"
                  label="State"
                  size="small"
                  value={member.State || ""}
                  disabled
                  sx={{
                    "& .MuiSelect-select": {
                      textAlign: "left",
                    },
                  }}
                >
                  {states.map((state, index) => (
                    <MenuItem key={index} value={state}>{state}</MenuItem>
                  ))}
                </Select>
              </FormControl>

              <TextField
                fullWidth
                disabled
                label="Pincode"
                type="number"
                size="small"
                name="Pincode"
                value={member.Pincode || ""}
                sx={styles.field}
              />
            </Grid>
          </Grid>
        );
      case 1:
        return (
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom sx={styles.sectionTitle}>
                Personal Details
              </Typography>
              <TextField
                fullWidth
                size="small"
                label="Occupation"
                name="Occupation"
                value={formData.Occupation}
                onChange={handleChange}
                sx={styles.field}
                error={!!errors.Occupation}
                helperText={errors.Occupation || ""}
                required
              />
              <TextField
                fullWidth
                size="small"
                label="Address"
                name="Address"
                value={formData.Address}
                onChange={handleChange}
                sx={styles.field}
                error={!!errors.Address}
                helperText={errors.Address || ""}
                required

              />
              <TextField
                fullWidth
                size="small"
                label="Email ID"
                name="Email"
                value={formData.Email}
                onChange={handleChange}
                sx={styles.field}
                error={!!errors.Email}
                helperText={errors.Email || ""}
                // required
              />
              <TextField
                fullWidth
                size="small"
                label="Family Details"
                name="Family_Details"
                value={formData.Family_Details}
                onChange={handleChange}
                sx={styles.field}
                error={!!errors.Family_Details}
                helperText={errors.Family_Details || ""}
                required
              />
              <FormControl fullWidth sx={{ mb: 3 }} error={!!errors.Marital_Status}>
                <Autocomplete
                  options={maritalStatusOptions}
                  value={formData.Marital_Status}
                  onChange={(event, newValue) => {
                    setFormData(prev => ({ ...prev, Marital_Status: newValue }));
                    if (newValue) {
                      setErrors(prev => ({ ...prev, Marital_Status: '' }));
                    }
                  }}
                  onInputChange={(event, inputValue) => {
                    const matchedOption = maritalStatusOptions.find(
                      option => option.toLowerCase() === inputValue.toLowerCase()
                    );
                    if (matchedOption && matchedOption !== formData.Marital_Status) {
                      setFormData(prev => ({ ...prev, Marital_Status: matchedOption }));
                      setErrors(prev => ({ ...prev, Marital_Status: '' }));
                      if (maritalStatusInputRef.current) maritalStatusInputRef.current.blur();
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      inputRef={maritalStatusInputRef}
                      label="Marital Status *"
                      variant="outlined"
                      size="small"
                      error={!!errors.Marital_Status}
                      helperText={errors.Marital_Status || ""}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#primary', // Yellow border
                          },
                        },

                      }}
                    />
                  )}
                  // PopperComponent={StyledPopper}
                  disableClearable
                  fullWidth
                  autoHighlight
                />


              </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom sx={styles.sectionTitle}>
                Astrological Details
              </Typography>
              <Autocomplete
                options={stars}
                value={formData.Star}
                onChange={(event, newValue) => {
                  setFormData(prev => ({ ...prev, Star: newValue }));
                }}
                onInputChange={(event, inputValue) => {
                  const matchedOption = stars.find(
                    option => option.toLowerCase() === inputValue.toLowerCase()
                  );
                  if (matchedOption && matchedOption !== formData.Star) {
                    setFormData(prev => ({ ...prev, Star: matchedOption }));
                    if (starInputRef.current) starInputRef.current.blur();
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    inputRef={starInputRef}
                    label="Star"
                    variant="outlined"
                    size="small"
                    sx={styles.field}
                  />
                )}
                disableClearable
                fullWidth
                autoHighlight
              />
              <Autocomplete
                options={raasis}
                value={formData.Raasi}
                onChange={(event, newValue) => {
                  setFormData(prev => ({ ...prev, Raasi: newValue }));
                }}
                onInputChange={(event, inputValue) => {
                  const matchedOption = raasis.find(
                    option => option.toLowerCase() === inputValue.toLowerCase()
                  );
                  if (matchedOption && matchedOption !== formData.Raasi) {
                    setFormData(prev => ({ ...prev, Raasi: matchedOption }));
                    if (raasiInputRef.current) raasiInputRef.current.blur();
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    inputRef={raasiInputRef}
                    label="Raasi"
                    variant="outlined"
                    size="small"
                    sx={styles.field}
                  />
                )}
                disableClearable
                fullWidth
                autoHighlight
              />
              <TextField
                fullWidth
                size="small"
                label="Gothram"
                name="Kootram"
                value={formData.Kootram}
                onChange={handleChange}
                sx={styles.field}
              />
              <TextField
                fullWidth
                size="small"
                label="Kuladeivam"
                name="Kuladeivam"
                value={formData.Kuladeivam}
                onChange={handleChange}
                sx={styles.field}
              />

              {/* ID Proof Section */}
              <FormControl
                component="fieldset"
                sx={{ mt: 2, mb: 2, width: '100%', textAlign: 'left' }}
                error={!!errors.ID_Proof_Type}
              >
                <FormLabel
                  component="legend"
                  sx={{
                    ...styles.sectionLabel,
                    textAlign: 'left',
                    color: errors.ID_Proof_Type ? '#d32f2f' : 'inherit'
                  }}
                >
                  ID Proof Type *
                </FormLabel>
                <RadioGroup
                  row
                  name="ID_Proof_Type"
                  value={formData.ID_Proof_Type}
                  onChange={handleRadioChange}
                  sx={{ justifyContent: 'flex-start' }}
                >
                  {idProofTypes.map(({ value, label }) => (
                    <FormControlLabel
                      key={value}
                      value={value}
                      control={<Radio />}
                      label={label}
                      sx={{ marginRight: 3 }}
                    />
                  ))}
                </RadioGroup>
                {errors.ID_Proof_Type && (
                  <FormHelperText sx={{ ml: 0 }}>{errors.ID_Proof_Type}</FormHelperText>
                )}
              </FormControl>

              {/* Aadhaar Input */}
              {formData.ID_Proof_Type === "aadhaar" && (
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Aadhaar Number"
                    type="text"
                    name="ID_Proof_Number"
                    value={formData.ID_Proof_Number}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "").slice(0, 12);
                      setFormData((prev) => ({ ...prev, ID_Proof_Number: value }));
                    }}
                    error={!!errors.ID_Proof_Number}
                    helperText={errors.ID_Proof_Number || " "}
                    placeholder="Enter Aadhaar Number"
                    required
                  />
                </Grid>
              )}

              {/* License Input */}
              {formData.ID_Proof_Type === "license" && (
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    label="License Number"
                    type="text"
                    name="ID_Proof_Number"
                    value={formData.ID_Proof_Number}
                    onChange={handleChange}
                    error={!!errors.ID_Proof_Number}
                    helperText={errors.ID_Proof_Number || " "}
                    inputProps={{ maxLength: 15 }}
                    onInput={(e) =>
                      (e.target.value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 15))
                    }
                    placeholder="Enter License Number"
                    required
                  />
                </Grid>
              )}

              {/* PAN Card Section (Mandatory) */}
              <FormControl
                component="fieldset"
                sx={{ mt: 4, mb: 2, width: '100%', textAlign: 'left' }}
                error={!!errors.Pan_Card}
                required
              >
                <FormLabel
                  component="legend"
                  sx={{
                    ...styles.sectionLabel,
                    textAlign: 'left',
                    color: errors.Pan_Card ? '#d32f2f' : 'inherit'
                  }}
                >
                  PAN Card
                </FormLabel>
                <RadioGroup
                  row
                  name="Pan_Card"
                  value={formData.Pan_Card}
                  onChange={handlePanChange}
                  sx={{ justifyContent: 'flex-start' }}
                >
                  {panCardOptions.map(({ value, label }) => (
                    <FormControlLabel
                      key={value}
                      value={value}
                      control={<Radio />}
                      label={label}
                      sx={{ marginRight: 3 }}
                    />
                  ))}
                </RadioGroup>

                {errors.Pan_Card && (
                  <FormHelperText sx={{ ml: 0 }}>{errors.Pan_Card}</FormHelperText>
                )}
              </FormControl>

              {/* PAN Number (Only if selected Yes) */}
              {formData.Pan_Card === "Yes" && (
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    label="PAN Number"
                    name="Pan_Number"
                    placeholder="Enter PAN Number"
                    value={formData.Pan_Number}
                    onChange={handleChange}
                    error={!!errors.Pan_Number}
                    helperText={errors.Pan_Number || " "}
                    inputProps={{ maxLength: 10 }}
                    onInput={(e) =>
                      (e.target.value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 10))
                    }
                    required
                  />
                </Grid>
              )}
            </Grid>
          </Grid>
        );
      case 2:
        return (
          <Box sx={styles.paymentContainer}>
  <CheckCircleIcon sx={styles.paymentIcon} />
  <Typography variant="h5" gutterBottom sx={styles.paymentTitle}>
    {isSubmitted ? "Details Submitted Successfully!" : "Ready for Payment"}
  </Typography>
  <Typography variant="body1" sx={styles.paymentText}>
    Your membership fee is ₹2000. This one-time payment will give you access to all membership benefits.
  </Typography>
  <Typography variant="body1" sx={styles.paymentText}>
    For transactions other than ₹2000, please contact TKS Admin at{" "}
    <a href="tel:+919841818740" style={{ color: "#2E2E2E",fontWeight: "36px", textDecoration: "bold" }}>
      +91 9841818740
    </a>{" "}
    or{" "}
    <a href="mailto:finance@tkstrust.com" style={{ color: "#2E2E2E",fontWeight: "36px", textDecoration: "bold" }}>
      finance@tkstrust.com
    </a>
  </Typography>
</Box>

        );
      case 3:
        if (isPanValid) {
          // Show Membership ID Card
          return (
            <Box sx={styles.successContainer}>
              <CheckCircleIcon sx={styles.successIcon} />
              <Typography variant="h4" gutterBottom sx={styles.successTitle}>
                Congratulations!
              </Typography>
              <Typography variant="h6" sx={styles.successSubtitle}>
                You are now officially a TKS Member
              </Typography>

              <Card
                sx={{
                  mt: 4,
                  width: "fit-content",
                  p: 2,
                  backgroundColor: "#fff",
                  borderRadius: 3,
                  position: "relative",
                  boxShadow: 4,
                }}
              >
                {/* Top-right download button */}
                <Box
                  sx={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <Button
                    color="black"
                    size="small"
                    startIcon={<DownloadIcon />}
                    onClick={handleDownloadIDCard}
                    sx={{
                      textTransform: "none",
                      fontWeight: "bold",
                      color: "#333",
                      px: 2,
                      borderRadius: "8px",
                      backgroundColor: "#f5f5f5",
                      transition: "all 0.3s ease",
                      '&:hover': {
                        background: "linear-gradient(135deg, #B4AB57, #947F49)",
                        color: "#fff",
                        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
                      },
                    }}
                  >
                    Download
                  </Button>
                </Box>

                {/* Member Card */}
                <Box ref={cardRef} display="flex" justifyContent="center" mt={4}>
                  <TKSMemberCard member={member} />
                </Box>
              </Card>
            </Box>
          );
        } else {
          // Show Payment Receipt
          return (
            <Box sx={styles.successContainer}>
              <CheckCircleIcon sx={styles.successIcon} />
              <Typography variant="h4" gutterBottom sx={styles.successTitle}>
                Payment Successful!
              </Typography>
              <Typography variant="h6" sx={styles.successSubtitle}>
                Thank you for completing your membership payment.
              </Typography>
              <Typography variant="body1" sx={{ mt: 2 }}>
                Please note: Membership ID Card is only generated if you provide a valid PAN number.
              </Typography>

            </Box>
          );
        }

      default:
        return null;
    }
  };

  const renderActionButtons = () => {
    if (activeStep === 1) {
      return (

        <>
          <Button
            disabled={activeStep === 0}
            onClick={handleBack}
            sx={styles.backButton}
          >
            Back
          </Button>



          <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>

            <Button
              variant="contained"
              onClick={handleSubmit}
              disabled={isLoading}
              sx={styles.submitButton}
            >
              {isLoading ? <CircularProgress size={24} color="inherit" /> : "Submit Details"}
            </Button>
          </motion.div>
        </>

      );
    } else if (activeStep === 2) {
      return (
        <>

          <Button
            disabled={activeStep === 0}
            onClick={() => { navigate('/profile'); window.scrollTo(0, 0); }}
            sx={styles.backButton}
          >
            Skip
          </Button>


          <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
            <Button
              variant="contained"
              onClick={handleProceedPayment}
              disabled={isPaymentLoading}
              sx={styles.paymentButton}
            >
              {isPaymentLoading ? <CircularProgress size={24} color="inherit" /> : "Proceed to Payment"}
            </Button>
            <div ref={paymentContainer} id="razorpay-container" style={{ width: "100%", height: "0px" }}></div>
          </motion.div>


        </>

      );
    } else if (activeStep === 3) {
      return (
        <Button
          variant="contained"
          onClick={() => {
            window.location.href = '/profile';
          }}
          sx={{
            ...styles.profileButton,
            borderRadius: '999px', // ✅ Ensure it's applied or overrides existing
          }}
        >
          Back to Profile
        </Button>

      );
    } else {
      return (
        <>
          <Button
            onClick={() => {
              if (activeStep === 0) {
                navigate('/profile');
                window.scrollTo(0, 0);
              } else {
                handleBack();
              }
            }}
            sx={styles.backButton}
          >
            Back
          </Button>
          <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
            <Button
              variant="contained"
              onClick={handleNext}
              sx={styles.nextButton}
            >
              Next
            </Button>
          </motion.div>
        </>
      );
    }
  };

  return (
    <Box sx={styles.container}>
      <Container maxWidth="lg">
        <Typography variant="h4" sx={styles.title}>
          Complete Your Membership Profile
        </Typography>

        <Box sx={styles.stepperContainer}>
          <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>

        <Grid container spacing={4}>
          <Grid item xs={12} md={8}>
            <Box sx={styles.formContainer}>
              {renderFormStep()}

              <Box sx={styles.buttonContainer}>
                {renderActionButtons()}
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Card sx={styles.sidebarCard}>
              <CardContent>
                <Typography variant="h6" gutterBottom sx={styles.sidebarTitle}>
                  Membership Benefits
                </Typography>
                <ul style={styles.benefitsList}>
                  <li>Membership benefits will be updated shortly.</li>
                  {/* <li>Access to all community events</li>
                  <li>Priority booking for cultural programs</li>
                  <li>Discounts on community services</li>
                  <li>Monthly newsletter</li>
                  <li>Voting rights in community decisions</li> */}
                </ul>
                <Divider sx={{ my: 2 }} />
                <Typography variant="subtitle1" sx={styles.paymentInfo}>
                  One-time payment: <strong>₹2000</strong>
                </Typography>
                {activeStep === 3 && (
                  <Box sx={{ mt: 3 }}>
                    <Typography variant="body2" sx={styles.securePayment}>
                      <CheckCircleIcon sx={{ fontSize: 16, mr: 1 }} />
                      Secure payment processing
                    </Typography>
                  </Box>
                )}
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
          sx={styles.alert}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        sx={styles.dialog}
      >
        <DialogTitle sx={styles.dialogTitle}>Important Notice</DialogTitle>
        <DialogContent sx={styles.dialogContent}>
          Please note: The Membership ID card will only be generated if you select <em>'Yes'</em> and provide your PAN Card number.
          If you select <em>'No'</em>, the ID card will <strong>not</strong> be generated.
        </DialogContent>
        <DialogActions sx={styles.dialogActions}>
          <Button
            onClick={() => setOpenDialog(false)}
            variant="contained"
            sx={styles.nextButton}
          >
            I Understand
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

const ConfirmationRow = ({ label, value }) => (
  <Box sx={styles.confirmationRow}>
    <Typography variant="body1" sx={styles.confirmationLabel}>
      {label}:
    </Typography>
    <Typography variant="body1" sx={styles.confirmationValue}>
      {value || "-"}
    </Typography>
  </Box>
);

const LoadingIndicator = () => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
    <CircularProgress color="success" />
  </Box>
);

const ErrorDisplay = ({ message }) => (
  <Box sx={styles.errorContainer}>
    <Typography color="error">{message}</Typography>
  </Box>
);

const NoDataFound = () => (
  <Box sx={styles.noDataContainer}>
    <Typography>No member data found</Typography>
  </Box>
);

const styles = {
  container: {
    backgroundColor: "#f8f9e9",
    py: 6,
    minHeight: "100vh",
  },
  title: {
    fontWeight: 600,
    color: "#2A289C",
    textAlign: "center",
    mb: 4,
  },
  stepperContainer: {
    width: "100%",
    mb: 4,
    px: { xs: 1, sm: 2 }, // Less padding on extra-small screens
    overflowX: "auto",    // Allow horizontal scrolling if steps overflow
  },
  formContainer: {
    backgroundColor: "#f8f9e9",
    borderRadius: 2,
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
    p: 4,
  },
  sectionTitle: {
    textAlign: "left",// or "center", "right" – your choice
    fontWeight: 700,
    fontSize: "1.75rem", // tweak size as you like
    background: "linear-gradient(120deg, #E52029, #FFFA80)", // vibrant gradient
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
  field: {
    mb: 3,
    "& .MuiInputBase-root": {
      backgroundColor: "#f8f9e9",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#ccc",
      },
      "&:hover fieldset": {
        borderColor: "#primary", // on hover
      },
      "&.Mui-focused fieldset": {
        borderColor: "#primary !important",
        borderWidth: "2px",
      },
    },
    // ✅ Apply hover effect for dropdown options
    "& .MuiPaper-root .MuiMenuItem-root:hover": {
      backgroundColor: "#f1f1e4", // your hover color
      color: "#000", // optional: make text visible if background is yellow
    },
  },

  sectionLabel: {
    fontWeight: 500,
    color: "#555",
    mb: 1,
    display: "block",

  },
  buttonContainer: {
    display: "flex",
    justifyContent: "space-between",
    mt: 4,
  },
  backButton: {
    color: "#666",
    borderRadius: '999px',
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.05)",
    },
  },
  nextButton: {
    backgroundColor: "#2A289C",
    color: "#fff",
    borderRadius: '999px',
    "&:hover": {
      backgroundColor: "#1a1970",
    },
    px: 4,
    py: 1,
  },
  submitButton: {
    backgroundColor: "#2A289C",
    borderRadius: '999px',
    color: "#fff",
    "&:hover": {
      backgroundColor: "#1a1970",
    },
    px: 4,
    py: 1,
    width: "100%"
  },
  paymentButton: {
    backgroundColor: "#2A289C",
    color: "#fff",
    borderRadius: '999px',
    "&:hover": {
      backgroundColor: "#1a1970",
    },
    px: 4,
    py: 1,
    width: "100%"
  },
  sidebarCard: {
    height: "100%",
    backgroundColor: "#f8f9e9",
    borderRadius: 2,
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
  },
  sidebarTitle: {
    fontWeight: 600,
    color: "#2A289C",
    mb: 2,
  },
  benefitsList: {
    paddingLeft: 2,
    "& li": {
      marginBottom: 1,
      fontSize: "0.95rem",
    },
  },
  paymentInfo: {
    fontWeight: 500,
    color: "#2A289C",
    textAlign: "center",
  },
  securePayment: {
    display: "flex",
    alignItems: "center",
    color: "#4CAF50",
  },
  confirmationCard: {
    backgroundColor: "#f8f9e9",
    borderRadius: 2,
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
  },
  confirmationTitle: {
    fontWeight: 600,
    color: "#2A289C",
    mb: 3,
    textAlign: "center",
  },
  confirmationSection: {
    fontWeight: 600,
    color: "#555",
    mb: 2,
  },
  confirmationRow: {
    display: "flex",
    justifyContent: "space-between",
    mb: 1,
    py: 1,
    borderBottom: "1px solid #eee",
  },
  confirmationLabel: {
    fontWeight: 500,
    color: "#666",
  },
  confirmationValue: {
    fontWeight: 400,
    color: "#333",
  },
  paymentContainer: {
    textAlign: "center",
    py: 4,
  },
  paymentIcon: {
    fontSize: 80,
    color: "#4CAF50",
    mb: 2,
  },
  paymentTitle: {
    fontWeight: 600,
    color: "#2A289C",
    mb: 2,
  },
  paymentText: {
    color: "#555",
    mb: 2,
    maxWidth: 500,
    mx: "auto",
  },
  paymentNote: {
    color: "#777",
    fontStyle: "italic",
  },
  alert: {
    width: "100%",
    fontSize: "16px",
    fontWeight: "bold",
  },
  dialog: {
    "& .MuiPaper-root": {
      borderRadius: 2,
      maxWidth: 500,
    },
  },
  dialogTitle: {
    fontWeight: 600,
    color: "#2A289C",
    textAlign: "center",
  },
  dialogContent: {
    color: "#555",
    py: 2,
  },
  dialogActions: {
    justifyContent: "center",
    pb: 3,
  },
  errorContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "50vh",
  },
  noDataContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "50vh",
  },
  successContainer: {
    textAlign: "center",
    py: 1,
    display: "flex",              // 🔑 Enable flexbox
    flexDirection: "column",     // Stack items vertically
    alignItems: "center",        // Center horizontally
    justifyContent: "center",    // Optional: center vertically if needed
  },

  successIcon: {
    fontSize: 80,
    color: "#4CAF50",
    mb: 2,
  },
  successTitle: {
    fontWeight: 700,
    color: "#2A289C",
    mb: 1,
  },
  successSubtitle: {
    fontWeight: 600,
    color: "#444",
    mb: 4,
  },
  membershipCardContainer: {
    justifyContent: "centre",
    margin: '0 10%',
    mb: 4,
  },
  downloadButtons: {
    display: 'flex',
    justifyContent: 'center',
    gap: 2,
    mt: 3,
  },
  downloadButton: {
    px: 4,
    py: 1.5,
  },
  profileButton: {
    backgroundColor: "#2A289C",
    color: "#fff",
    '&:hover': {
      backgroundColor: "#1a1970",
    },
    px: 3,         // Horizontal padding inside the button
    py: 1,         // Vertical padding inside the button
    width: 'fit-content', // Shrinks to the button's content
    mt: 0,         // Top margin
    ml: '35%',     // Manually push to the right (~center)
  },
};